export default __webpack_public_path__ + "static/media/Panda-Cake.f2e914d0.jpg";